import { APP_CONFIG } from '@/config';
import { WOHNEN_PLUS_PATH } from '@/domain/routes';
import { KAEUFER_PLUS_PATH } from '@/domain/routes';
import { MIETER_PLUS_PATH } from '@/domain/routes';

const { quickCartUrl, wohnenPlusLP } = APP_CONFIG;

// CMP (Campaign) parameters for different types of campaigns
const CMP_PREMIUM = `&cmp_name=premium_profile_living&cmp_position=residential_benefits`;
const CMP_LIVING = `&cmp_name=premium_profile_living&cmp_position=residential_benefits`;
// Legacy campaign parameter - keeping for backward compatibility
const CMP_ADDRESS_CHANGE = `&cmp_name=address_change_plus&cmp_position=residential_benefits`;

// New campaign parameters for address change
const CMP_ADDRESS_CHANGE_WOHNENPLUS = `cmp_id=10-052786&cmp_name=address_change&cmp_position=residential_benefits&cmp_creative=wohnenplus_cta`;
const CMP_ADDRESS_CHANGE_KAEUFERPLUS = `cmp_id=10-052785&cmp_name=address_change&cmp_position=residential_benefits&cmp_creative=kaeuferplus_cta`;
const CMP_ADDRESS_CHANGE_MIETERPLUS = `cmp_id=10-052784&cmp_name=address_change&cmp_position=residential_benefits&cmp_creative=mieterplus_cta`;
const CMP_PLUS_RENT_PLUS = `&cmp_name=plus_rent_plus&cmp_position=residential_benefits`;
const CMP_PLUS_LIVING_PLUS = `&cmp_name=plus_living_plus&cmp_position=residential_benefits`;
const CMP_PLUS_BUY_PLUS = `&cmp_name=plus_buy_plus&cmp_position=residential_benefits`;
const CMP_TENANT_PROPERTYHUB = `&cmp_name=premium_profile_living&cmp_position=tenant_propertyhub`;

// Campaign parameters for tenant view WP upsell with MP entitlement (30%)
const CMP_TENANT_WP_UPSELL_MP = {
  LEARN_MORE:
    '?cmp_id=10-052794&cmp_name=premium_profile_living&cmp_position=tenant_propertyhub&cmp_creative=mp_overlay_more',
  BUY_NOW:
    '?cmp_id=10-052793&cmp_name=premium_profile_living&cmp_position=tenant_propertyhub&cmp_creative=mp_overlay_cta',
};

// Campaign parameters for tenant view WP upsell with or without WP entitlement (15%)
const CMP_TENANT_WP_UPSELL_WP = {
  LEARN_MORE:
    '?cmp_id=10-052796&cmp_name=premium_profile_living&cmp_position=tenant_propertyhub&cmp_creative=overlay_more',
  BUY_NOW: '?cmp_id=10-052795&cmp_name=premium_profile_living&cmp_position=tenant_propertyhub&cmp_creative=overlay_cta',
};

// IDs for specific articles and configurations
const MIETERPLUS_ARTICLE_ID = 6676;
const MIETERPLUS_CONFIGURATION_ID = 'b9ca90df-a6f2-4adf-9d8c-733a2f33cae9';
const EXPERIMENT_ADDRESS_CHANGE = '&experiment=addressChange';
export const CMP_UPSELL = `?cmp_id=10-052578${CMP_LIVING}&cmp_creative=overlay_cta`;
export const CMP_UPSELL_EXPERIMENTAL = `?cmp_id=10-052840${CMP_LIVING}&cmp_creative=overlay_cta`;

/**
 * Campaign URLs for different services and promotions.
 * Each key represents a specific campaign and its value is the URL with the necessary parameters.
 */
export const campaigns = {
  BILLCHECK_LEARN_MORE: `${wohnenPlusLP}?cmp_id=10-051971${CMP_LIVING}&cmp_creative=overlay_more`,
  SCHLUESSELDIENST: `${quickCartUrl}/wohnenplus?cmp_id=10-052071${CMP_PREMIUM}&cmp_creative=key_service_cta`,
  RECHTSBERATUNG: `${quickCartUrl}/wohnenplus?cmp_id=10-052071${CMP_PREMIUM}&cmp_creative=legal_advice_cta`,
  MEDIATION: `${quickCartUrl}/wohnenplus?cmp_id=10-052585${CMP_PREMIUM}&cmp_creative=mediation_cta`,
  MIETRECHTSSCHUTZ: `${quickCartUrl}/wohnenplus?cmp_id=10-052584${CMP_PREMIUM}&cmp_creative=legal_insurance_cta`,
  BILLCHECK: `${quickCartUrl}/wohnenplus?cmp_id=10-052444${CMP_PREMIUM}&cmp_creative=utilitybill_cta`,
  LAGERRAUM: `${quickCartUrl}/wohnenplus?cmp_id=10-052069${CMP_PREMIUM}&cmp_creative=lagerbox_cta`,
  UPSELL_BANNER: `${quickCartUrl}/wohnenplus?cmp_id=10-052584${CMP_PREMIUM}&cmp_creative=livingplus_cta`,
  MEIN_PLUS_WP_UPSELL_MODAL: {
    DISCOUNTED: {
      LEARN_MORE: `${quickCartUrl}/wohnenplus?cmp_id=10-052579${CMP_LIVING}&cmp_creative=overlay_more`,
      BUY_NOW: CMP_UPSELL,
    },
    DISCOUNTED_EXPERIMENTAL: {
      LEARN_MORE: `${quickCartUrl}/wohnenplus?cmp_id=10-052841${CMP_LIVING}&cmp_creative=overlay_more`,
      BUY_NOW: CMP_UPSELL_EXPERIMENTAL,
    },
  },
  UPSELL_MODAL_LEARN_MORE: `${quickCartUrl}/wohnenplus`,
  UPSELL_MODAL_BUY_NOW: `${quickCartUrl}/wohnenplus/zahlung/`,
  UPSELL_MODAL_LEARN_MORE_TENANT_MP: `${quickCartUrl}/wohnenplus${CMP_TENANT_WP_UPSELL_MP.LEARN_MORE}`,
  UPSELL_MODAL_BUY_NOW_TENANT_MP: `${quickCartUrl}/wohnenplus/zahlung/{articleId}${CMP_TENANT_WP_UPSELL_MP.BUY_NOW}`,
  UPSELL_MODAL_LEARN_MORE_TENANT_WP: `${quickCartUrl}/wohnenplus${CMP_TENANT_WP_UPSELL_WP.LEARN_MORE}`,
  UPSELL_MODAL_BUY_NOW_TENANT_WP: `${quickCartUrl}/wohnenplus/zahlung/{articleId}${CMP_TENANT_WP_UPSELL_WP.BUY_NOW}`,
  ADDRESS_CHANGE_BENEFIT_MAPPING: {
    [WOHNEN_PLUS_PATH]: CMP_ADDRESS_CHANGE_WOHNENPLUS,
    [KAEUFER_PLUS_PATH]: CMP_ADDRESS_CHANGE_KAEUFERPLUS,
    [MIETER_PLUS_PATH]: CMP_ADDRESS_CHANGE_MIETERPLUS,
  },
  ADDRESS_CHANGE: `${quickCartUrl}/mieterplus?cmp_id=10-052577?cmp_id=10-052640&${CMP_ADDRESS_CHANGE}&cmp_creative=address_change_ad&articleConfigurationId=${MIETERPLUS_CONFIGURATION_ID}&selectedArticle=${MIETERPLUS_ARTICLE_ID}${EXPERIMENT_ADDRESS_CHANGE}`,
  MAGENTA_TV_CHECKOUT_MP: `${quickCartUrl}/mieterplus?cmp_id=10-052753${CMP_PLUS_RENT_PLUS}&cmp_creative=magentatv_cta`,
  MAGENTA_TV_CHECKOUT_WP: `${quickCartUrl}/wohnenplus?cmp_id=10-052755${CMP_PLUS_LIVING_PLUS}&cmp_creative=magentatv_cta`,
  MAGENTA_TV_CHECKOUT_KP: `${quickCartUrl}/kaeuferplus?cmp_id=10-052754${CMP_PLUS_BUY_PLUS}&cmp_creative=magentatv_cta`,
  // MFE campaigns for tenant property hub
  RECHTSBERATUNG_MFE: `${quickCartUrl}/wohnenplus?cmp_id=10-052773${CMP_TENANT_PROPERTYHUB}&cmp_creative=legal_advice_cta`,
  SCHLUESSELDIENST_MFE: `${quickCartUrl}/wohnenplus?cmp_id=10-052774${CMP_TENANT_PROPERTYHUB}&cmp_creative=key_service_cta`,
  MEDIATION_MFE: `${quickCartUrl}/wohnenplus?cmp_id=10-052775${CMP_TENANT_PROPERTYHUB}&cmp_creative=mediation_cta`,
  BILLCHECK_MFE: `${quickCartUrl}/wohnenplus?cmp_id=10-052776${CMP_TENANT_PROPERTYHUB}&cmp_creative=utilitybill_cta`,
  LAGERRAUM_MFE: `${quickCartUrl}/wohnenplus?cmp_id=10-052777${CMP_TENANT_PROPERTYHUB}&cmp_creative=lagerbox_cta`,
  MIETRECHTSSCHUTZ_MFE: `${quickCartUrl}/wohnenplus?cmp_id=10-052778${CMP_TENANT_PROPERTYHUB}&cmp_creative=legal_insurance_cta`,
  MAGENTA_TV_MFE: `${quickCartUrl}/wohnenplus?cmp_id=10-052779${CMP_TENANT_PROPERTYHUB}&cmp_creative=magentatv_cta`,
  // MFE campaigns for address change
  ADDRESS_CHANGE_MFE: `?cmp_id=10-052816&cmp_name=address_change&cmp_position=tenant_propertyhub&cmp_creative=addresschange_cta`,
  // Women's Day special campaign - redirects to Wohnen+ quickcart
  WOMENS_DAY_WOHNEN_PLUS_MEIN_PLUS: `${quickCartUrl}/wohnenplus?cmp_id=10-052976&cmp_name=premium_profile_living&cmp_position=residential_benefits&cmp_creative=international_women_day_cta`,
  WOMENS_DAY_WOHNEN_PLUS_SUCCESS_MODAL: `${quickCartUrl}/wohnenplus?cmp_id=10-052977&cmp_name=premium_profile_living&cmp_position=residential_benefits&cmp_creative=international_women_day_cta`,
  // Women's Day voucher checkout deep-link (voucherCode appended dynamically)
  WOMENS_DAY_VOUCHER_CHECKOUT_URL: `${quickCartUrl}/wohnenplus/zahlung/6620?articleConfigurationId=f47ac10b-58cc-4372-a567-0e02b2c3d479&selectedArticle=6620&voucherCode=`,
  TENANT_NETWORK_SUCHEN_PLUS: `/meinkonto/premium-mitgliedschaft/?cmp_id=10-052960&cmp_name=residential_profile&cmp_position=residential_benefits&cmp_creative=tenantnetwork_cta`,
  // Klarwatt green electricity voucher link (prod-only landing page, does not exist in sandbox)
  KLARWATT_LANDING_PAGE: 'https://www.immobilienscout24.de/lp/klarwatt/tarifrechner.html?voucherCode=26KWWP6',
  KLARWATT_DISCOVER_WOHNEN_PLUS: `${quickCartUrl}/wohnenplus?cmp_id=10-052071${CMP_PREMIUM}&cmp_creative=legaladvice_cta`,
} as const;

/**
 * URL for the address change standalone payment process (legacy).
 */
export const ADDRESS_CHANGE_STANDALONE_PAYMENT_URL = `${quickCartUrl}/adresswechsel/zahlung/6596`;
